import { type PropsWithChildren, useEffect, useState } from 'react';
import type { PageContextType } from '../../types';
import { useNavigation } from '../hooks/use-navigation';
import { PageContext } from '../hooks/use-page';

const defaultPageState: PageContextType['scrollState'] = {
  hasScroll: false,
  isAtBottom: false
};

export function PageContextProvider({ children }: PropsWithChildren) {
  const { currentPage } = useNavigation();
  const [scrollState, setScrollState] =
    useState<PageContextType['scrollState']>(defaultPageState);

  useEffect(() => {
    setScrollState(defaultPageState);
  }, [currentPage]);

  return (
    <PageContext.Provider
      value={{
        scrollState,
        setScrollState
      }}
    >
      {children}
    </PageContext.Provider>
  );
}
